// Static SVG icons - no React components, no rerenders
export const HomeIcon = (
  <svg width={20} height={20} viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="#525252"
      fillRule="evenodd"
      d="M10 19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9a1 1 0 0 1 .35-.76l7-6a1 1 0 0 1 1.3 0l7 6A1 1 0 0 1 20 10v9a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-6h-4zm-5 0v-9l7-6 7 6v9h-4v-6a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v6z"
      clipRule="evenodd"
    />
  </svg>
)

export const SearchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    viewBox="0 0 14 14"
  >
    <path
      fill="#6F6F6F"
      d="M6.5.5a6 6 0 0 1 4.58 9.873l2.774 2.774.064.078a.5.5 0 0 1-.693.693l-.079-.064-2.773-2.774A6 6 0 1 1 6.5.5Zm0 1a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z"
    />
  </svg>
)

export const PlusIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
  >
    <path
      fill="#161616"
      d="M6 0a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 6 0Z"
    />
  </svg>
)

export const UserIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={13}
    viewBox="0 0 12 13"
  >
    <path d="M6 9a6.992 6.992 0 0 1 5.747 3.004.48.48 0 0 1-.053.612c-.233.236-.62.167-.812-.102A5.99 5.99 0 0 0 6 10a5.993 5.993 0 0 0-4.883 2.515c-.193.268-.578.337-.811.102a.48.48 0 0 1-.054-.612A6.992 6.992 0 0 1 6 9Zm0-9a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" />
  </svg>
)

export const ChevronIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={5}
    viewBox="0 0 10 5"
  >
    <path d="M8.725.082a.5.5 0 0 1 .693.694l-.064.078-4 4a.5.5 0 0 1-.707 0l-4-4L.582.776a.5.5 0 0 1 .694-.694l.078.065L5 3.793 8.647.147l.078-.065Z" />
  </svg>
)

export const ArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
  >
    <path d="M15.775 16.918a.5.5 0 0 1-.693-.694l.064-.078L17.293 14H8.5a3.5 3.5 0 0 1 0-7h1a.5.5 0 0 1 0 1h-1a2.5 2.5 0 0 0 0 5h8.793l-2.146-2.147-.065-.078a.5.5 0 0 1 .693-.693l.079.064 3 3a.5.5 0 0 1 0 .707l-3 3-.079.065Z" />
  </svg>
)

export const BinIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={16}
    viewBox="0 0 14 16"
  >
    <path
      fill="#525252"
      d="M8 0a2 2 0 0 1 2 2h2.5a1.5 1.5 0 0 1 .463 2.926l-.84 9.255A2 2 0 0 1 10.13 16H3.87a2 2 0 0 1-1.966-1.629l-.026-.19-.842-9.255A1.5 1.5 0 0 1 1.5 2H4a2 2 0 0 1 2-2h2ZM2.874 14.09l.013.095A1 1 0 0 0 3.87 15h6.26a1 1 0 0 0 .996-.91L11.952 5H2.048l.826 9.09ZM5.5 7a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5Zm3 0a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5Zm-7-4a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11ZM6 1a1 1 0 0 0-1 1h4a1 1 0 0 0-1-1H6Z"
    />
  </svg>
)

export const CopyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    viewBox="0 0 12 12"
  >
    <path
      fill="#6f6f6f"
      d="M7.5 0A1.5 1.5 0 0 1 9 1.5V3h1.5A1.5 1.5 0 0 1 12 4.5v6a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 3 10.5V9H1.5A1.5 1.5 0 0 1 0 7.5v-6A1.5 1.5 0 0 1 1.5 0h6ZM9 7.5A1.5 1.5 0 0 1 7.5 9H4v1.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5H9v3.5ZM1.5 1a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-6Z"
    />
  </svg>
)

export const CompanyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    viewBox="0 0 13 13"
  >
    <path d="M6.103.005A1 1 0 0 1 7 1v4h2V3.5a.5.5 0 0 1 1 0V5h2l.102.005A1 1 0 0 1 13 6v6l-.005.102a1 1 0 0 1-.893.893L12 13H1l-.103-.005a1 1 0 0 1-.892-.893L0 12V1A1 1 0 0 1 .897.005L1 0h5l.103.005ZM7 12h5V6H7v6Zm-6 0h1v-2a1 1 0 0 1 .897-.995L3 9h1l.103.005A1 1 0 0 1 5 10v2h1V1H1v11Zm2 0h1v-2H3v2Z" />
  </svg>
)

export const LinkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
  >
    <path d="M7.646 10.646a.5.5 0 0 1 .707.707l-2.5 2.5a3.036 3.036 0 0 0 4.293 4.294l2.501-2.5a.5.5 0 0 1 .707.707l-2.5 2.5a4.036 4.036 0 0 1-5.708-5.708l2.5-2.5Zm6.5-1.5a.5.5 0 0 1 .707.707l-5 5-.078.065a.5.5 0 0 1-.693-.693l.064-.079 5-5Zm-1-4a4.037 4.037 0 0 1 5.708 5.708l-2.5 2.5a.5.5 0 0 1-.708-.708l2.501-2.5a3.036 3.036 0 0 0-4.294-4.293l-2.5 2.5a.5.5 0 0 1-.707-.707l2.5-2.5Z" />
  </svg>
)

export const MoreIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 10.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m6 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m6 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3" />
  </svg>
)

export const InfoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
  >
    <path d="M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm0 1a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm0 5a.5.5 0 0 1 .5.5V15a.5.5 0 0 1-1 0v-3.5a.5.5 0 0 1 .5-.5Zm0-2.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z" />
  </svg>
)

export const GlobeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
  >
    <path d="M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm-1.99 7.5c.053 1.623.354 3.043.788 4.056.24.559.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.237-.234.498-.623.737-1.182.434-1.013.735-2.433.787-4.056h-3.978Zm-3.988 0a6.001 6.001 0 0 0 4.268 5.251c-.724-1.175-1.215-3.076-1.281-5.251H6.022Zm8.97 0c-.067 2.176-.559 4.076-1.283 5.251a6 6 0 0 0 4.268-5.251h-2.986ZM10.29 6.248A6.002 6.002 0 0 0 6.022 11.5H9.01c.066-2.176.556-4.077 1.281-5.252ZM12 6c-.076 0-.232.032-.465.262-.237.234-.498.623-.737 1.182-.434 1.013-.735 2.433-.787 4.056h3.978c-.052-1.623-.353-3.043-.787-4.056-.24-.559-.5-.948-.737-1.182C12.232 6.032 12.076 6 12 6Zm1.709.248c.725 1.175 1.216 3.076 1.282 5.252h2.986a6.002 6.002 0 0 0-4.268-5.252Z" />
  </svg>
)

export const FilterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
  >
    <path
      fill="#525252"
      d="M8.407.11A7.9 7.9 0 0 1 15.9 8l-.01.407A7.9 7.9 0 0 1 8 15.9l-.407-.01A7.9 7.9 0 0 1 .111 8.407L.1 8A7.9 7.9 0 0 1 8 .1l.407.01ZM8 1.1a6.9 6.9 0 1 0 0 13.801A6.9 6.9 0 0 0 8 1.1Z"
    />
    <path
      stroke="#525252"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.5 8.5h5M6.5 11.5h3M4.5 5.5h7"
    />
  </svg>
)

export const BackIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={8}
    viewBox="0 0 16 8"
  >
    <path
      stroke="#6F6F6F"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.257.757 1 4m0 0 3.257 3.243M1 4h14"
    />
  </svg>
)

export const PeopleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={12}
    viewBox="0 0 14 12"
  >
    <path d="M3.5 6A3.5 3.5 0 0 1 7 9.5v2a.5.5 0 0 1-1 0v-2a2.5 2.5 0 0 0-5 0v2a.5.5 0 0 1-1 0v-2A3.5 3.5 0 0 1 3.5 6Zm7 0A3.5 3.5 0 0 1 14 9.5v2a.5.5 0 0 1-1 0v-2a2.5 2.5 0 0 0-5 0c0-.686-.153-1.335-.428-1.917A3.496 3.496 0 0 1 10.5 6Zm-7-6a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm7 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" />
  </svg>
)

export const TickIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7}
    height={7}
    viewBox="0 0 6 6"
  >
    <path
      fill="none"
      stroke="#525252"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m.5 2.5 2 3 3-5"
    />
  </svg>
)

export const EnterIcon = (
  <svg
    width="8"
    height="10"
    viewBox="0 0 8 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.69 9.35C2.71 8.202 1.674 7.362 0.61 6.83V6.424C1.674 5.892 2.71 5.038 3.69 3.904H4.502C4.04 4.884 3.592 5.64 3.144 6.13H6.504V0.852H7.498V7.124H3.144C3.592 7.614 4.04 8.37 4.502 9.35H3.69Z"
      fill="white"
    />
  </svg>
)

export const ExternalLink = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={1.75}
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      d="M15 3h6v6m-11 5L21 3m-3 10v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
    />
  </svg>
)

export const MessageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={1.25}
    viewBox="0 0 24 24"
  >
    <path
      fill="white"
      d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zM7 11h10M7 15h6M7 7h8"
    />
  </svg>
)
